import { onBeforeUnmount, watch } from "vue";

export function useCamPhotoStatusPolling(source, pollAction, options = {}) {
  const intervalMs = options.intervalMs ?? 5000;
  const maxAttempts = options.maxAttempts ?? 24;
  const onTimeout = options.onTimeout ?? (() => {});

  let intervalId = null;
  let attempts = 0;

  const stop = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }

    attempts = 0;
  };

  watch(
    source,
    ([logUuid, photoMediaUuid, shouldPoll]) => {
      stop();

      if (!logUuid || photoMediaUuid || !shouldPoll) {
        return;
      }

      intervalId = setInterval(async () => {
        attempts += 1;

        await pollAction();

        if (attempts >= maxAttempts) {
          stop();
          onTimeout();
        }
      }, intervalMs);
    },
    { immediate: true },
  );

  onBeforeUnmount(() => {
    stop();
  });

  return {
    stop,
  };
}
